module.exports = __webpack_public_path__ + "media/newstyle/images/icon-person-white-d8463e156a46afa4464c490c84660bdc.svg";